module.exports = __webpack_public_path__ + "static/media/button_down.cbebeaef.svg";